import Hero from "../components/Hero";
import BrandStory from "../components/BrandStory";
import Collections from "../components/Collections";
import ArtisanStories from "../components/ArtisanStories";
import Donation from "../components/Donation";
import PartnerSection from "../components/PartnerSection";
import DressesTeaser from "../components/DressesTeaser";
import MoireSection from "../components/MoireSection";
import Testimonials from "../components/Testimonials";
import Newsletter from "../components/Newsletter";
import FinalCTA from "../components/FinalCTA";
import useSEO from "../hooks/useSEO";
import useReveal from "../hooks/useReveal";

/**
 * Heritage-first homepage.
 * All Etsy CTAs live in heritage-related sections only (Hero, Collections, FinalCTA).
 * Dresses is a teaser linking to /dresses (coming-soon mode, no Etsy).
 */
export default function HomePage() {
  useReveal();
  useSEO({
    title: "Kendi Collections | African Art, Handmade Crafts & Artisan Work",
    description:
      "Kendi Collections is a Melbourne-based boutique of African handmade crafts — handwoven baskets, beaded jewellery, wooden carvings, and contemporary African art. Supporting artisans across the continent.",
    keywords:
      "African art, handmade crafts, artisan work, African baskets, beaded jewellery, wooden carvings, Maasai, Etsy boutique, cultural artifacts, Melbourne",
    canonical: "https://kendicollections.shop/",
    ogTitle: "Kendi Collections | African Art, Handmade Crafts & Artisan Work",
    ogDescription:
      "A curated boutique of African handmade crafts and contemporary art. Every piece is made by hand, supporting artisans across the continent.",
  });

  return (
    <div data-testid="home-page">
      {/* 1. Hero — heritage primary with Etsy CTA */}
      <Hero />

      {/* 2. Brand story */}
      <BrandStory />

      {/* 3. Heritage collections — Etsy links */}
      <Collections />

      {/* 4. Artisan stories */}
      <ArtisanStories />

      {/* 5. Donation (linked from artisan stories #support) */}
      <Donation />

      {/* 5b. Trusted partner (trust signal, subtle) */}
      <PartnerSection />

      {/* 6. Dresses teaser — coming soon, no Etsy */}
      <DressesTeaser />

      {/* 6b. MOIRÉ — powered by Kendi Collections */}
      <MoireSection />

      {/* 7. Trust + newsletter */}
      <Testimonials />
      <Newsletter />

      {/* 8. Final heritage Etsy CTA */}
      <FinalCTA variant="heritage" />
    </div>
  );
}
